/*
  Reihenfolge der Kaufspalte, wenn Globo den Konfigurator stellt.

  Globo laeuft als App-Embed und schreibt sein Feld selbst in das
  Kaufformular — an einer eigenen Stelle, nicht zwingend dort, wo die
  Schritt-Ueberschrift "Schritt 2 Personalisierung" im Theme steht (die
  Ueberschrift ist ein Theme-Block). Gemessen: der Trigger fuer die
  Schriftart-Vorschau landete dadurch VOR "Schritt 2" statt danach.

  Gleiches Prinzip wie zuvor bei Zepto (siehe Git-Historie
  la-pdp-zepto.js, inzwischen entfernt): die Ueberschrift wandert zu den
  Feldern, nicht umgekehrt. Verschoben wird ausschliesslich eigenes
  Theme-Markup (Ueberschriften, Schriftart-Vorschau-Trigger); an Globos
  Elementen aendert das Skript nichts.

  Anders als Zeptos .product-personalizer liegt Globos .gpo-app NICHT
  zwingend innerhalb eines <form> — ein form-Erfordernis wie beim
  Zepto-Vorbild wuerde hier fuer jedes Produkt scheitern. Der Sammel-Knopf
  (.product-form-buttons) wird deshalb direkt im wurzel-Bereich gesucht,
  nicht ueber ein <form> als Zwischenschritt.

  Globo rendert asynchron nach, deshalb wird auf sein Erscheinen gewartet
  statt auf einen festen Zeitpunkt.
*/
(() => {
  const MAX_WARTEN = 15000;

  const einsortieren = (wurzel) => {
    const felder = wurzel.querySelector('.gpo-app');
    if (!felder) return false;

    const schrittPersonalisierung = wurzel.querySelector('[data-config-step="personalization"]');
    const schrittAbschluss = wurzel.querySelector('[data-config-step="cta"]');
    const knoepfe = wurzel.querySelector('.product-form-buttons');
    // Der Trigger lebt in einer eigenen Section (la-font-preview), nicht
    // innerhalb von .la-pdp-v6 — deshalb ueber document suchen, nicht
    // ueber wurzel.
    const schriftVorschauTrigger = document.querySelector('[data-font-preview-open]');

    const feldWrapper = felder.closest('.shopify-block') || felder;

    if (schrittPersonalisierung && feldWrapper.parentElement && !feldWrapper.closest('.la-pplr-feld')) {
      const huelle = document.createElement('div');
      huelle.className = 'la-pplr-feld';
      feldWrapper.parentElement.insertBefore(huelle, feldWrapper);
      huelle.appendChild(schrittPersonalisierung);
      if (schriftVorschauTrigger) huelle.appendChild(schriftVorschauTrigger);
      huelle.appendChild(feldWrapper);
    }
    if (schrittAbschluss && knoepfe && knoepfe.parentElement) {
      knoepfe.parentElement.insertBefore(schrittAbschluss, knoepfe);
    }

    wurzel.classList.add('la-pdp-globo-bereit');
    return true;
  };

  const starten = () => {
    document.querySelectorAll('.la-pdp-v6').forEach((wurzel) => {
      if (einsortieren(wurzel)) return;

      // Noch nicht da — auf Globos Einschub warten.
      const beobachter = new MutationObserver(() => {
        if (einsortieren(wurzel)) beobachter.disconnect();
      });
      beobachter.observe(wurzel, { childList: true, subtree: true });
      setTimeout(() => beobachter.disconnect(), MAX_WARTEN);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }

  // Ein Variantenwechsel rendert die Kaufspalte neu; danach steht die
  // Reihenfolge wieder auf dem Ausgangszustand.
  document.addEventListener('variant:update', starten);
  document.addEventListener('shopify:section:load', starten);
})();
